import type { SharedData } from '../../types';

type ShareOpener = (data: SharedData) => void;

let currentOpener: ShareOpener | null = null;

export function registerInstagramShareOpener(opener: ShareOpener): () => void {
  currentOpener = opener;

  return () => {
    if (currentOpener === opener) {
      currentOpener = null;
    }
  };
}

export function openInstagramShare(data: SharedData): void {
  currentOpener?.(data);
}
